<template>
  <v-card class="pa-2 mt-5" elevation="1">
    <v-empty-state
      :text="text"
      image="/svg/no-preview-available.svg"
      size="100"
    >
      <template #title>
        <div class="mt-6 text-body-medium font-weight-medium">
          {{ t('documents.preview.cant_be_previewed') }}
        </div>
      </template>

      <template #actions>
        <v-spacer />

        <v-btn color="primary" @click="emit('click:btn', $event)">
          {{ t('actions.download') }}
        </v-btn>

        <v-spacer />
      </template>
    </v-empty-state>
  </v-card>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

defineProps({
  text: {
    type: String,
    default: undefined,
  },
})

const { t } = useI18n()

const emit = defineEmits(['click:btn'])
</script>
